(function ($) {

	'use strict';
  
	var is_focus_active = false;
	var is_hover_active = false;
  
	$(document).ready(function() {

	});
  
  
	/** --------------------------------------------------
	  #drupal behaviour
	  -------------------------------------------------- */
  
	  Drupal.behaviors.checkFocus = {
		attach: function (context) {

		  const form = $('#mailchimp-signup-subscribe-block-subscribe-form');
  
		  /* When hover set an active state and show pop-up */

		  $('.mailchimp-signup-subscribe-form').hover(
			function() {
  
			  form.addClass('js-show-gdpr');
			  is_hover_active = true;
  
			}, function() {
  
			  if(!is_focus_active && is_hover_active) {
				form.removeClass('js-show-gdpr');
				is_hover_active = false;
			  }
  
			}
		  );
  
  
		  /* When focus (via tab) is active also show the pop-up */
		  $('#mailchimp-signup-subscribe-block-subscribe-form input').focus(function() {
  
			form.addClass('js-show-gdpr');
			is_focus_active = true;
  
		  }).blur(function() {
  
			form.removeClass('js-show-gdpr');
			is_focus_active = false;
  
		  });
  
		  $('.general-terms-conditions-wrapper a').focus(function() {
  
			form.addClass('js-show-gdpr');
			is_focus_active = true;
  
		  }).blur(function() {
  
			form.removeClass('js-show-gdpr');
			is_focus_active = false;
  
		  }); 
  
  
		}
	  };
  
  })(jQuery);
  